import React, { useState } from 'react';

const TextInputWithAutoComplete = ({
                                     placeholder,
                                     id, suggestions = [],
                                     isDisabled = false,
                                     value,
                                     onChange,
                                   }) => {
  const normalizedValue = value || '';
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(-1);

  const normalizeInputValue = (value) => {
    return value && value.trim().replace(/\s+/g, ' ');
  };

  const handleBlur = (e) => {
    const normalizedValue = normalizeInputValue(value);
    const matchingSuggestion = suggestions.find((suggestion) => {
      if (suggestion == null) return false;
      return suggestion?.toLowerCase() === normalizedValue?.toLowerCase();
    });

    onChange(matchingSuggestion || normalizedValue);

    const relatedTarget = e.relatedTarget;
    const clickedSuggestion = relatedTarget?.closest('.suggestions-list');

    if (!clickedSuggestion) {
      setShowSuggestions(false);
      setActiveSuggestionIndex(-1);
    }
  };

  const handleChange = (e) => {
    const userInput = e.currentTarget.value;
    onChange(userInput);

    if (suggestions.length > 0) {
      const filtered = suggestions.filter((suggestion) => suggestion.toLowerCase().includes(userInput.toLowerCase()));
      setFilteredSuggestions(filtered);
      setShowSuggestions(filtered.length > 0);
      setActiveSuggestionIndex(-1);
    } else {
      setFilteredSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    onChange(suggestion);
    setFilteredSuggestions([]);
    setShowSuggestions(false);
    setActiveSuggestionIndex(-1);
  };

  const handleKeyDown = (e) => {
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        if (filteredSuggestions.length > 0) {
          setActiveSuggestionIndex((prevIndex) => prevIndex < filteredSuggestions.length - 1 ? prevIndex + 1 : prevIndex);
        }
        break;

      case 'ArrowUp':
        e.preventDefault();
        if (filteredSuggestions.length > 0) {
          setActiveSuggestionIndex((prevIndex) => prevIndex > 0 ? prevIndex - 1 : 0);
        }
        break;

      case 'Enter':
        e.preventDefault();
        if (activeSuggestionIndex >= 0 && activeSuggestionIndex < filteredSuggestions.length) {
          handleSuggestionClick(filteredSuggestions[activeSuggestionIndex]);
        } else if (filteredSuggestions.length === 1) {
          handleSuggestionClick(filteredSuggestions[0]);
        }
        break;

      case 'Escape':
        e.preventDefault();
        setShowSuggestions(false);
        setActiveSuggestionIndex(-1);
        break;

      default:
        break;
    }
  };

  return (
    <div className="position-relative">
      <input
        type="text"
        id={id}
        placeholder={placeholder}
        className="text-input-mepos mepos-input form-control text-dark fs-7 rounder-4px h-100 py-3"
        value={normalizedValue}
        onBlur={handleBlur}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        autoComplete="off"
        maxLength={50}
        disabled={isDisabled}
      />
      {showSuggestions && filteredSuggestions.length > 0 && (
        <ul className="suggestions-list rounder-4px bg-white position-absolute w-100 mt-1 px-2 py-2 z-5">
          {filteredSuggestions.map((suggestion, index) => (
            <li
              key={index}
              className={`rounder-4px px-2 py-2 bg-white text-dark cursor-pointer ${index === activeSuggestionIndex ? 'active' : ''}`}
              onMouseDown={() => handleSuggestionClick(suggestion)}
            >
              {suggestion}
            </li>))}
        </ul>)}
    </div>
  );
};

export default TextInputWithAutoComplete;